<template>
  <router-view />
</template>

<script>
export default {
  name: 'Deal'
};
</script>
